import { styled } from '@mui/system';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const CustomAccordion = styled(({ title, description, styles = {} }) => (
  <Accordion sx={styles.container} square>
    <AccordionSummary
      expandIcon={<ArrowDropDownIcon fontSize='medium' sx={{ color: '#000000' }} />}
      sx={styles.summary}
    >
      {title}
    </AccordionSummary>
    <AccordionDetails sx={styles.details}>{description}</AccordionDetails>
  </Accordion>
))({});

export default CustomAccordion;
